<template>
  <div id="contenedor-eliminar-contrat-fecha">
    <v-card>
      <v-card-title>
        Eliminar fecha contrato
      </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la <b>{{ textoEliminar }}</b>? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarContratoFecha"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixContratoFechas from './mixContratoFechas';

export default {
  name: 'EliminarContratoFecha',
  mixins: [mixContratoFechas],
  components: {
    CustomButton,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    idContrato: {
      type: String,
      required: true,
    },
    textoEliminar: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
